import React, { useMemo } from 'react';
import { Input } from 'antd-mobile'
import AddonBefore from './addonBefore'
import Validator from './validator'
import styles from './index.scss'
import classnames from 'classnames'

interface IDMicroPhoneProps {
  value: string
  onChange?: Function
  beforeProps?: {
    options?: {
      value: string
      label: string
    }[],
    addonBeforeType?: string // default api 下拉是api还是外部的options
  }
  configType?: string // 配置方式，是否有前缀，默认配置和国际化配置 default、‌i18n‌Config
  maxLength?: number
  disabled?: boolean
  placeholder?: string
  customStyles?: React.CSSProperties
}

const DpPhoneNumber = React.forwardRef((props: IDMicroPhoneProps,  ref: any) => {
  const { beforeProps, configType, value, maxLength, customStyles, ..._props } = props
  const _value = useMemo(() => {
    if (configType === '‌i18n‌Config') {
      let initValue = []
      if (value?.indexOf('-') > -1) {
        initValue = value.split('-')
      } else {
        initValue = ['', value]
      }
      return {
        prefix: initValue?.[0] || '+86',
        phone: initValue?.[1],
      }
    }
    return {
      phone: value
    }
  }, [value])

  const onChangeInput = (value?: string | undefined) => {
    props?.onChange?.(configType === '‌i18n‌Config' ? `${_value?.prefix}-${value || ''}` : (value || ''))
  }

  const _maxLength = useMemo(() => {
    if (maxLength || configType !== '‌i18n‌Config') {
      return maxLength || 11
    }
    if (configType === '‌i18n‌Config' && _value?.prefix === '+86') {
      return 11
    } else {
      return 1000
    }
  }, [_value?.prefix])
  return (
    <div className={classnames({
      [styles['dp-phone']]: true,
      'dp-phone': true,
      'dp-phone-i18n': configType === '‌i18n‌Config'
    })} style={customStyles}>
      {
        configType === '‌i18n‌Config' &&
          <AddonBefore
            customStyles={customStyles}
            hotSource={[{
              "code": "B51",
              "phonePre": "+86",
              "name": "中国",
              "firstWord": "Z"
            }, {
              "code": "B88",
              "phonePre": "+852",
              "name": "中国香港",
              "firstWord": "Z"
            }, {
              "code": "B121",
              "phonePre": "+853",
              "name": "中国澳门",
              "firstWord": "Z"
            }, {
              "code": "B203",
              "phonePre": "+886",
              "name": "中国台湾",
              "firstWord": "Z"
            }]}
            disabled={_props?.disabled}
            {...props?.beforeProps}
            value={_value?.prefix}
            onChange={(e: string) => {
              e && props?.onChange?.(`${e}-${_value?.phone || ''}`)
            }}
          />
      }
      <Input
        placeholder={lang['请输入']}
        {..._props}
        maxLength={_maxLength}
        value={_value?.phone}
        onChange={onChangeInput}
      />
    </div>
  )
})
DpPhoneNumber.defaultProps = {
  beforeProps: {
    addonBeforeType: 'default' // default api
  }
}
DpPhoneNumber.Validator = Validator
export default DpPhoneNumber;
